import axios from 'axios';

export const create = (currentEntityTypeId, formData, callback) => {
  var promise = axios({
    method: 'post',
    url: Routes.abstract_bulk_load_documents_path(currentEntityTypeId, {'format': 'json'}),
    data: formData,
    headers: {
      "X-CSRF-TOKEN": window.compliance.token
    }
  });

  promise.then(response => {
    callback(response);
  }).catch(error => {
    callback(error.response);
  });
}
